import PropTypes from "prop-types";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Media } from "solar/components/Media";
import "mapbox-gl/dist/mapbox-gl.css";
import Map, { NavigationControl } from "react-map-gl";
import LocationMapModal from "components/stay/LocationMapModal";
import LocationMapMarker from "components/stay/LocationMapMarker";
import styles from "components/stay/LocationMap.module.scss";

export default function LocationMap({
  latitude,
  longitude,
  tripTypeDescription,
}) {
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);
  const greaterThanLg = useMediaQuery({
    query: `(min-width: ${styles.solBreakpointLg}px)`,
  });

  const mapboxApiAccessToken = process.env.NEXT_PUBLIC_MAPBOX_API_KEY;
  const showMarker = tripTypeDescription === "Lodge";
  const initialZoom = showMarker ? 15 : 5;

  const [viewState, setViewState] = useState({
    latitude,
    longitude,
    zoom: initialZoom,
  });

  return (
    <div className={styles.component}>
      <Map
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...viewState}
        onMove={(evt) => setViewState(evt.viewState)}
        style={{ width: "100%", height: "100%" }}
        mapStyle="mapbox://styles/rteuscher/cksygrnfkxye917p6gsc8qlt7"
        mapboxAccessToken={mapboxApiAccessToken}
        onRender={(event) => event.target.resize()}
        attributionControl={false}
        interactive={greaterThanLg}
      >
        {showMarker && (
          <LocationMapMarker latitude={latitude} longitude={longitude} />
        )}
        <Media greaterThanOrEqual="lg">
          <NavigationControl className={styles.controls} showCompass={false} />
        </Media>
        <Media lessThan="lg">
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className={styles.action}
          />
        </Media>
      </Map>
      <LocationMapModal
        latitude={latitude}
        longitude={longitude}
        showMarker={showMarker}
        initialZoom={initialZoom}
        mapboxApiAccessToken={mapboxApiAccessToken}
        show={showModal}
        handleClose={handleModalClose}
      />
    </div>
  );
}

LocationMap.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  tripTypeDescription: PropTypes.string.isRequired,
};
